import React, { useState, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from '../common/react-redux-hooks';
import ACEditContext from './ACContext/ACEditContext';
import AutocodeTabs from './AutocodeTabs';
import CommonStudySelector from '../common/CommonStudySelector';
import backButtonArrow from '../../images/Autocode/backButtonArrow.svg';
import IconFolderClose from './ACShared/IconFolderClose';
import ACSelectionBoxContext from './ACContext/ACSelectionBoxContext';
import autocodeSelectionReducer from './ACContext/acSelectionBoxReducer';
import { AC_ROOT_NODE_ID,
         AC_SAMPLE_LIMIT, 
         AC_SAMPLE_NCS_LIMIT 
       } from './AutocodeConstants';
import AutocodeSelectionAction from './AutocodeSelectionBox/AutocodeSelectionActions';
import { useACSelectionBoxContext } from './ACContext/ACSelectionBoxContext';

const Autocode = props => {
  const {
    studies,
    featureID,
    defaultStudy,
    alertMsg,
    menuName,
    selectedWeightType,
    gridData,
    handleStudyChange,
    runReport,
    children,
    uid,
    trackerFn,
    moduleAction,
    BasesDataGridData,
    ColumnsDataGridData,
    RowsDataGridData,
    ScratchDataGridData,
    showAddSaveDefinitionBtn = false,
    showBulkJoinBtn = false,
    showCRBBtns = false,
    showTargetBtn = false,
    rightSideClass,
    canAddNewFolders = false,
    showTargetEllipsis = false,
    canAddNewDefinitions = false,
    showDefFolderEllipsis = false,
    showDefEditBtn = false,
    toggleDragDrop = false,
    sampleLimit = AC_SAMPLE_LIMIT,
    sampleNCSLimit = AC_SAMPLE_NCS_LIMIT,
    showSmplWghtDisplay = false,
    isSelectionBoxEmptyFlag = false,
  } = props;
  // const [study, setStudy] = useState(defaultStudy);
  const {
    loginResponse,
    activeAccountId,
    partsToShow,
    deBuildTargets,
    errorSelectionBox,
    addTargetAPIFlag,
    tempTarget,
    editTarget, } = useSelector(
    state => ({
      loginResponse: state.login.loginResponse,
      activeAccountId: state.account.activeAccountId,
      partsToShow: state.crosstab.partsToShow,
      deBuildTargets: state.deBuild.deBuildTargets,
      errorSelectionBox: state.deBuild.errorSelectionBox,
      addTargetAPIFlag: state.deBuild.addTargetAPIFlag,
      tempTarget: state.deBuild.tempTarget,
      editTarget: state.deBuild.editTarget,
    })
  );
  const acSelContext = useACSelectionBoxContext();
  const [editMode, seteditMode] = useState(false);
  const [createDefMode, setcreateDefMode] = useState(false);
  const [backToDef, setbackToDef] = useState(false);
  const [editFolderDetails, seteditFolderDetails] = useState([]);
  const [tabIndex, settabIndex] = useState(0);
  const [state, dispatch] = useReducer(autocodeSelectionReducer, {
    setTabsIndex: tab => {
      settabIndex(tab);
    },
    partsToShow,
    sampleLimit,
    sampleNCSLimit,
    showSmplWghtDisplay,
    allOpNodes: [],
    topLevelOpNodes: [],
    rootNode: {
      type: 'root',
      id: AC_ROOT_NODE_ID,
      selected: false,
      combined: false,
      children: [],
      // eslint-disable-next-line no-unused-vars
      toLabelString(pts) {
        return '';
      },
      toExpressionString() {
        return '';
      },
      toExpressionArray() {
        return [];
      },
    },
  });
  const {
    setBackToRootNode
  } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);

  const generateGridData = gridData => {
    const data = {
      selectedKeywords: [],
      selectedNames: [],
      originalNames: [],
      recTypes: [],
      dataSmartSearch: [],
      isLabelUpdated: [],
    };
    // eslint-disable-next-line react/prop-types
    gridData.forEach(item => {
      data.selectedKeywords.push(item.keyword);
      data.selectedNames.push(item.title);
      data.originalNames.push(item.originalTitle);
      data.recTypes.push(item.recType || item.rectype || item.type);
      data.dataSmartSearch.push(item.dataSmartSearch);
      data.isLabelUpdated.push(item.isLabelUpdated);
    });
    return data;
  };

  const getSampleWeightedOfExistingKPIs = weightList => {
    let sampleWeightedParams = {
      token: loginResponse.data.token,
      uid: loginResponse.data.uid,
      accountId: activeAccountId,
      productNo: defaultStudy.pn,
      weightType: weightList.wt,
      divisor: weightList.dv || 1000,
      weightChange: true,
    };

    if (BasesDataGridData && BasesDataGridData.length > 0) {
      const userStateData = generateGridData(BasesDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'BasesDataGrid',
        targetGrid: 'BasesDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      moduleAction.getSampleWeighted(sampleWeightedParams);
    }

    if (ColumnsDataGridData && ColumnsDataGridData.length > 0) {
      const userStateData = generateGridData(ColumnsDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ColumnsDataGrid',
        targetGrid: 'ColumnsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
        isLabelUpdated: userStateData.isLabelUpdated,
      };
      moduleAction.getSampleWeighted(sampleWeightedParams);
    }

    if (RowsDataGridData && RowsDataGridData.length > 0) {
      const userStateData = generateGridData(RowsDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'RowsDataGrid',
        targetGrid: 'RowsDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
        isLabelUpdated: userStateData.isLabelUpdated,
      };
      moduleAction.getSampleWeighted(sampleWeightedParams);
    }

    if (ScratchDataGridData && ScratchDataGridData.length > 0) {
      const userStateData = generateGridData(ScratchDataGridData);
      sampleWeightedParams = {
        ...sampleWeightedParams,
        sourceGrid: 'ScratchDataGrid',
        targetGrid: 'ScratchDataGrid',
        expressionList: userStateData.selectedKeywords,
        selectedNames: userStateData.selectedNames,
        originalNames: userStateData.originalNames,
        recTypes: userStateData.recTypes,
        objSmartSearchArray: userStateData.dataSmartSearch,
      };
      moduleAction.getSampleWeighted(sampleWeightedParams);
    }
  };

  return (
    <ACSelectionBoxContext.Provider
      value={{
        state,
        dispatch,
        trackerFn,
        deBuildTargets,
        errorSelectionBox,
        addTargetAPIFlag,
        tempTarget,
        editTarget,
      }}
    >
      <div className="autocode-container">
        <div className="row expanded">
          <div
            className="columns small-12 medium-9 large-9"
            style={{ paddingTop: '1rem' }}
          >
            {!(editMode || createDefMode) ? (
              <CommonStudySelector
                studies={studies}
                featureID={featureID}
                defaultStudy={defaultStudy}
                alertMsg={alertMsg}
                setMethod={handleStudyChange}
                showWeightType
                runReport={runReport}
                hideWeightType={false}
                menuName={menuName}
                selectedWeightType={selectedWeightType}
                getSampleWeightedOfExistingKPIs={
                  getSampleWeightedOfExistingKPIs
                }
                autocode
              />
            ) : (
              <div className="edit-mode-container">
                <div>
                  <span className="row pull-left edit-mode-container-tag">
                    {editMode ? 'Edit Definition' : 'Create Definition'}
                  </span>
                  <button
                    type="button"
                    className="row pull-right"
                    onClick={() => {
                      seteditMode(false);
                      setcreateDefMode(false);
                      setbackToDef(true);
                      setBackToRootNode(state.rootNode, dispatch);
                    }}
                  >
                    <img
                      style={{ paddingRight: '8px', marginBottom: '2px' }}
                      src={backButtonArrow}
                      alt="arrow"
                    />
                    Back to Definitions
                  </button>
                </div>
                {editMode && (
                  <div className="edit-mode-container-folder">
                    Definition Folder
                    <div>
                      <IconFolderClose fill="#7994BB" />
                      <span className="edit-mode-container-folder-name">
                        {editFolderDetails[0].selectedFolder.folderName}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}
            <ACEditContext.Provider
              value={{
                editMode,
                createDefMode,
                backToDef,
                editFolderDetails,
                seteditMode,
                setbackToDef,
                seteditFolderDetails,
                setcreateDefMode,
                showAddSaveDefinitionBtn,
                showBulkJoinBtn,
                showCRBBtns,
                showTargetBtn,
                canAddNewFolders,
                showTargetEllipsis,
                canAddNewDefinitions,
                showDefFolderEllipsis,
                showDefEditBtn,
                toggleDragDrop,
                isSelectionBoxEmptyFlag,
              }}
            >
              <AutocodeTabs
                moduleStudy={defaultStudy}
                activeAccountId={activeAccountId}
                uid={uid}
                selectedWeightType={selectedWeightType}
                gridData={gridData}
                trackerFn={trackerFn}
                editMode={editMode}
                backToDef={backToDef}
                createDefMode={createDefMode}
                partsToShow={partsToShow}
                tabIndex={tabIndex}
                settabIndex={settabIndex}
                moduleAction={moduleAction}
                menuName={menuName}
              />
            </ACEditContext.Provider>
          </div>
          <div className="autocode-right-col-container">
            <div className={`${rightSideClass}`}>{children}</div>
            {(editMode || createDefMode) && (
              <div className="autocode-editmode-layer" />
            )}
          </div>
        </div>
      </div>
    </ACSelectionBoxContext.Provider>
  );
};

Autocode.propTypes = {
  handleStudyChange: PropTypes.func,
  studies: PropTypes.arrayOf(PropTypes.object),
  featureID: PropTypes.number,
  defaultStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  alertMsg: PropTypes.string,
  menuName: PropTypes.string,
  selectedWeightType: PropTypes.shape({}),
  gridData: PropTypes.shape({
    BasesDataGrid: PropTypes.arrayOf(PropTypes.object),
    ColumnsDataGrid: PropTypes.arrayOf(PropTypes.object),
    RowsDataGrid: PropTypes.arrayOf(PropTypes.object),
  }),
  runReport: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.element),
  uid: PropTypes.number,
  moduleAction: PropTypes.shape({
    getSampleWeighted: PropTypes.func,
  }),
  ColumnsDataGridData: PropTypes.arrayOf(PropTypes.object),
  BasesDataGridData: PropTypes.arrayOf(PropTypes.object),
  RowsDataGridData: PropTypes.arrayOf(PropTypes.object),
  ScratchDataGridData: PropTypes.arrayOf(PropTypes.object),
  trackerFn: PropTypes.func,
  showAddSaveDefinitionBtn: PropTypes.bool,
  showBulkJoinBtn: PropTypes.bool,
  showCRBBtns: PropTypes.bool,
  showTargetBtn: PropTypes.bool,
  rightSideClass: PropTypes.string.isRequired,
  canAddNewFolders: PropTypes.bool,
  showTargetEllipsis: PropTypes.bool,
  canAddNewDefinitions: PropTypes.bool,
  showDefFolderEllipsis: PropTypes.bool,
  showDefEditBtn: PropTypes.bool,
  toggleDragDrop: PropTypes.bool,
  sampleLimit: PropTypes.number,
  sampleNCSLimit: PropTypes.number,
  showSmplWghtDisplay: PropTypes.bool,
  isSelectionBoxEmptyFlag: PropTypes.bool,
};

export default Autocode;
